import { Flex, Center, Text, Box } from '@chakra-ui/react';

interface InfoItemProps {
  icon: React.ReactNode;
  label: string;
  extra: React.ReactNode;
}

const InfoItem = ({ icon, label, extra }: InfoItemProps) => {
  return (
    <Flex px="3" gap="2.5" justifyContent="space-between">
      <Center fontSize="4xl">{icon}</Center>
      <Flex
        py="5"
        gap="5"
        justifyContent="space-between"
        alignItems="center"
        fontSize="sm"
        flex="1"
        borderBottom="1px solid"
        borderColor="border.subtle"
        fontWeight="medium"
      >
        <Text color="fg">{label}</Text>
        <Box overflow="hidden">{extra}</Box>
      </Flex>
    </Flex>
  );
};

const MemoizedInfoItem = memo(InfoItem);
export { MemoizedInfoItem as InfoItem };
